<template>
  <component :is="link ? 'a' : 'span'" :href="link" :aria-label="$t('text-search')" class="inline-block my-0.5" @click.prevent="link && onClick()">
    <component
      :is="link ? 'button' : 'span'"
      v-tippy="link ? $t('text-to-filter') : undefined"
      :style="tagStyles"
      :class="[
        'w-fit flex items-center justify-center rounded-full transition-colors  whitespace-nowrap mr-2',
        !highlighted ? 'bg-transparent border border-tag-border hover:border-tag-border-hover focus:border-tag-border-hover text-primary-light font-normal' : '',
        highlighted && config.public.layoutDesign === 'aquarist' ? 'bg-accent-light hover:accent-light-hover text-primary font-bold' : '',
        highlighted && config.public.layoutDesign === 'pipeclub' ? 'bg-accent-light hover:accent-light-hover text-light font-normal' : '',
        classesName
      ]"
    >
      <slot />
    </component>
  </component>
</template>

<script setup>

const props = defineProps({
  size: {
    type: String,
    default: 'tiny' // "big" | "medium" | "tiny"
  },
  link: {
    type: String,
    default: '#'
  },
  highlighted: {
    type: Boolean,
    default: false
  },
  styleSource: {
    type: Object,
    default: null
  },
  onClick: {
    type: Function,
    default: () => {}
  }
});

const classes = {
  tiny: 'px-5 py-0 h-6 text-2xs',
  small: 'px-5 py-0 h-9 text-sm',
  medium: 'px-5 py-0 h-12',
  big: 'px-6 py-0 h-15',
};

const config = useRuntimeConfig();

const tagStyles = computed(() => {
  const styles = {};

  if (props.styleSource?.colorBorder) {
    styles.borderColor = props.styleSource.colorBorder;
  }

  if (props.styleSource?.colorBackground) {
    styles.backgroundColor = props.styleSource.colorBackground;
  }

  if (props.styleSource?.colorFont) {
    styles.color = props.styleSource.colorFont;
  }

  return styles;
});

const classesName = computed(() => {
    return [
        classes.root,
        props.size === 'tiny' ? classes.tiny : '',
        props.size === 'small' ? classes.small : '',
        props.size === 'medium' ? classes.medium : '',
        props.size === 'big' ? classes.big : '',
    ];
});

</script>
